import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["truncated", "full"]
  static values = { expanded: Boolean }

  connect() {
    this.expandedValue = false
  }

  toggle(event) {
    event.preventDefault()
    this.expandedValue = !this.expandedValue
    this.render()
  }

  render() {
    if (this.expandedValue) {
      this.truncatedTarget.classList.add("hidden")
      this.fullTarget.classList.remove("hidden")
    } else {
      this.truncatedTarget.classList.remove("hidden")
      this.fullTarget.classList.add("hidden")
    }
  }
}
